import { FC } from 'react';

import SelectGiftWrapper from '../../../../components/select-gift';
import { ComponentTypeProps } from '../../../../types/page-generator';
import { SelectCoupon } from '../../../wallet/components/Coupons/SelectCoupon';

export const MyActiveCoupons: FC<ComponentTypeProps> = ({ block }) => <SelectCoupon />;
